export default __webpack_public_path__ + "static/media/gallery5.fdb294aa.png";